import React from 'react';
import { Tabs as MuiTabs, TabsProps as MuiTabsProps, tabClasses, tabsClasses } from '@mui/material';

export { tabsClasses };

export type TabsProps = MuiTabsProps & {
  color?: 'primary' | 'secondary';
};

export const Tabs = React.forwardRef<HTMLDivElement, TabsProps>(
  ({ color = 'primary', ...props }, ref) => {
    if (color === 'primary') {
      return <MuiTabs {...props} ref={ref} />;
    }

    return (
      <MuiTabs
        {...props}
        ref={ref}
        sx={(theme) => ({
          mx: 2,
          [`.${tabClasses.root}`]: {
            color: theme.palette.background.paper,
            opacity: 0.7,
            [`&.${tabClasses.selected}`]: {
              color: theme.palette.background.paper,
              opacity: 1,
            },
          },
          [`.${tabClasses.disabled}`]: {
            color: theme.palette.background.paper,
            opacity: 0.4,
          },
          [`.${tabsClasses.indicator}`]: {
            background: theme.palette.background.paper,
          },
        })}
      />
    );
  },
);
